import React, { useState } from "react"
import { Button } from "antd"
import { DownloadOutlined } from "@ant-design/icons"
import GetLabel from "DisplayFramework/components/GetLabel"
import ModalSFS from "components/theme_components/ModalSFS"
import ExportModal from "./ExportModal"


export interface ExportXLSProps {
  data: any[]
  columns?: string[]
  columnLabels?: Record<string, string>
  filename?: string
  label?: string
  className?: string
  type?: "primary" | "dashed" | "link" | "text" | "default"
  size?: "large" | "middle" | "small"
  disabled?: boolean
}

const ExportXLS = (props: ExportXLSProps) => {
  const {
    data,
    columns = [],
    columnLabels = {},
    filename = "export",
    label = "Export (.xls)",
    className = "ut-reset-btn ut-btn-no-border no-box-shadow",
    ...buttonProps
  } = props

  const [visible, setVisible] = useState(false)

  return (
    <ModalSFS
      trigger={({ setVisible }) => (
        <Button onClick={() => setVisible(true)} icon={<DownloadOutlined />} className={className} {...buttonProps}>
          <GetLabel label="export" className="color-blue font-weight-500" />
        </Button>
      )}
      title="chooseExportFormat"
    >
      <ExportModal
        data={data}
        filename={filename}
        columns={columns}
        columnLabels={columnLabels}
        setVisible={setVisible}
      />
    </ModalSFS>
  )
}

export default ExportXLS

// Add type definition for the XLSX library on the window object
declare global {
  interface Window {
    XLSX: any
  }
}
